import { init, track } from "@plausible-analytics/tracker";

const PLAUSIBLE_DOMAIN = "lovequetee.gallery";
let initialized = false;

const analyticsEnabled = () => (
  typeof window !== "undefined"
  && process.env.NODE_ENV === "production"
  && process.env.REACT_APP_ENABLE_PLAUSIBLE === "true"
  && window.location.protocol === "https:"
  && window.location.hostname === PLAUSIBLE_DOMAIN
);

export function initAnalytics() {
  if (!analyticsEnabled() || initialized) return false;
  init({
    domain: PLAUSIBLE_DOMAIN,
    endpoint: "https://plausible.io/api/event",
    autoCapturePageviews: false,
    hashBasedRouting: false,
    captureOnLocalhost: false,
    outboundLinks: false,
    fileDownloads: false,
    formSubmissions: false,
    customProperties: {},
    bindToWindow: true,
    logging: false,
  });
  initialized = true;
  return true;
}

export function trackPageview() {
  if (!initialized || !analyticsEnabled()) return;
  track("pageview");
}
